// Generated automatically before each production build.
export const CURRENT_BUILD_VERSION = "1793644412718";
